import React, { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import logo from "@/assets/bubble-radar-logo.png";
import { Link } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const LOGO_URL = logo;

export default function ResendVerificationPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, { email });
      toast.success("If the account exists, a verification email was sent.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Unable to resend verification email");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md -mt-6">
        <div className="flex justify-center mb-10" data-testid="resend-verification-logo-wrapper">
          <img
            src={LOGO_URL}
            alt="Bubble Radar logo"
            data-testid="resend-verification-logo"
            className="h-40 w-auto"
          />
        </div>
        <Card className="w-full">
          <CardHeader>
            <CardTitle className="text-lg" data-testid="resend-verification-title">
              Resend verification email
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={onSubmit} className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="resend-email" className="text-sm text-slate-600">Email</label>
                <Input
                  id="resend-email"
                  data-testid="resend-verification-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                />
              </div>
              <Button
                type="submit"
                className="w-full bg-slate-900 hover:bg-slate-800"
                data-testid="resend-verification-submit-button"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send verification email"}
              </Button>
              <div className="text-sm text-slate-600 text-center">
                <Link
                  to="/login"
                  className="hover:text-slate-900"
                  data-testid="resend-verification-login-link"
                >
                  Back to login
                </Link>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
